import { render, staticRenderFns } from "./UserWhiteboard.vue?vue&type=template&id=4c90f132&scoped=true&"
import script from "./UserWhiteboard.vue?vue&type=script&lang=js&"
export * from "./UserWhiteboard.vue?vue&type=script&lang=js&"
import style0 from "./UserWhiteboard.vue?vue&type=style&index=0&id=4c90f132&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c90f132",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
